/**
 * Mapas de íconos de stablecoins, compartidos por múltiples módulos
 * (transaction, contacts, movements, wallet). Promovidos a shared para evitar
 * imports cross-módulo.
 */

/** Ícono por bankCode corto (ETH, TRX, etc.). */
export const BANK_CODE_ICON_MAP: Record<string, string> = {
  ETH: 'icons/stablecoins/ethereum.png',
  TRX: 'icons/stablecoins/tron.png',
  SOL: 'icons/stablecoins/solana.png',
  ARB: 'icons/stablecoins/arbitrum.png',
  AVAX: 'icons/stablecoins/avalanche.png',
  BASE: 'icons/stablecoins/base.png',
  OP: 'icons/stablecoins/optimism.png',
  POL: 'icons/stablecoins/polygon.png',
};

/** Ícono por código de moneda stablecoin. */
export const STABLECOIN_CURRENCY_ICON_MAP: Record<string, string> = {
  USDT: 'icons/stablecoins/usdt.png',
  USDC: 'icons/stablecoins/usdc.png',
  PYUSD: 'icons/stablecoins/pyusd.png',
  BTC: 'icons/stablecoins/btc.png',
  ETH: 'icons/stablecoins/ethereum.png',
};

// Mapa por nombre de banco (accountBankName) para mostrar ícono de red en detalles de movimiento.
// El payload solo guarda accountBankId/accountBankName, no el bankCode corto (SOL, ETH, etc.).
export const BANK_NAME_ICON_MAP: Record<string, string> = {
  Ethereum: 'icons/stablecoins/ethereum.png',
  Tron: 'icons/stablecoins/tron.png',
  Solana: 'icons/stablecoins/solana.png',
  Arbitrum: 'icons/stablecoins/arbitrum.png',
  Avalanche: 'icons/stablecoins/avalanche.png',
  Base: 'icons/stablecoins/base.png',
  Optimism: 'icons/stablecoins/optimism.png',
  Polygon: 'icons/stablecoins/polygon.png',
};
